import {
  RoomStreamToSubscribeVORaw,
  roomStreamToSubscribeVORaw
} from "@youm-front/room/domain";
import { JsonSchemaValidator } from "@common/json-schema-validator";

export class RoomStreamToSubscribeVO {
  private static validation = JsonSchemaValidator.compile(
    RoomStreamToSubscribeVO.validationSchema()
  );

  constructor(readonly value: RoomStreamToSubscribeVORaw) {
    JsonSchemaValidator.assert(RoomStreamToSubscribeVO.validation, value);
  }

  private static validationSchema() {
    return roomStreamToSubscribeVORaw;
  }
}
